import React from "react";
import 'remixicon/fonts/remixicon.css';


interface HoverVideoPlayerProps {
    videoSrc: string,
    preload: string,
    srcType: string,
}

function HoverVideoPlayer(this: any, props: HoverVideoPlayerProps): JSX.Element {
    let vidElement: HTMLVideoElement | null = document.getElementById(props.videoSrc) as HTMLVideoElement;
    const [paused, setPaused] = React.useState(vidElement !== null ? vidElement.paused : true); 
    
    const play = (e: any) => {
        setPaused(false);
        vidElement?.play()
    }

    const pause = (e: any) => {
        setPaused(true);
        vidElement?.pause();
    }

    let videoPlayer = (
            <div className="relative inline-block">
                <video className="z-10 max-w-full max-h-full" id={props.videoSrc} key={props.videoSrc} preload={props.preload} controls controlsList="nodownload" disablePictureInPicture={false} loop={true} onMouseOver={play} onMouseOut={pause} playsInline={true} autoPlay={false} muted={true}>
                    <source src={props.videoSrc} type={props.srcType} />
                </video>
                <div className={!paused ? "hidden" : "flex absolute z-1 inset-0 max-w-full max-h-full m-auto text-center place-items-center content-center justify-center bg-black opacity-50"} onMouseOver={play}><span className="flex ri-play-fill text-teal-500 text-5xl"></span></div>
            </div>
    );

    return videoPlayer;
}

export function getElementDirection(fileSrc: string, fileType: string): string {
    return "";
}

export default HoverVideoPlayer;